import { useRef } from 'react';

/**
 * Hook that provides safe overlay dismiss handlers.
 * Prevents modal from closing when a drag-selection (e.g., selecting text in an input)
 * overshoots past the modal boundary onto the overlay.
 *
 * Only closes if both mousedown AND click originated on the overlay itself.
 */
export function useOverlayDismiss(onClose: () => void) {
  const mouseDownTargetRef = useRef<EventTarget | null>(null);

  const handleOverlayMouseDown = (e: React.MouseEvent) => {
    mouseDownTargetRef.current = e.target;
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (
      e.target === e.currentTarget &&
      mouseDownTargetRef.current === e.currentTarget
    ) {
      onClose();
    }
  };

  return { handleOverlayMouseDown, handleOverlayClick };
}
